import * as Action from "../action/sys_mgt_role.action"

const initState = {
    searchParams: {
        searchType: "",
        searchKeyword: "",
        pageNumber: 1,
        pageSize: 10
    },
    roleList: {
        isLoading: false,
        list: [],
        total: 0,
    },
    drawerInfo: {
        isLoading: false,
        visible: false,
        title: "",
        type: "add",
        data: {}
    }
}

/**
 * 角色管理reducer
 */
const roleReducer = (state = initState, action) => {
    switch (action.type) {
        case Action.SYS_MGT_ROLE_LIST_IS_LOADING: // 角色列表是否加载中
            return {...state, roleList: {...state.roleList, isLoading: action.isLoading}};
        case Action.SYS_MGT_SET_ROLE_DRAWER_INFO: // 设置抽屉信息
            return {...state, drawerInfo: {...state.drawerInfo, ...action.data}}
        case Action.SYS_MGT_GET_ROLE_LIST: // 角色列表
            return {...state, roleList: {...state.roleList, list: action.list, total: action.total}}
        case Action.SYS_MGT_ROLE_SET_SEARCH_PARAMS: // 设置查询参数
            return {...state, searchParams: {...state.searchParams, ...action.data}}
        case Action.SYS_MGT_ROLE_SET_DRAWER_INFO: // 设置抽屉信息
            return {...state, drawerInfo: {...state.drawerInfo, ...action.drawerInfo}}
        case Action.SYS_MGT_ROLE_EDIT_ROLE: // 编辑角色
            return {...state, roleList: {...state.roleList, list: [...state.roleList.list.map(role => {
                if(role.id == action.role.id){
                    return action.role
                }
                return role;})]}}
        default: return {...state};
    }
}

export default roleReducer;
